import React, {useState} from 'react';
import CreateEvent from './CreateEvent';
import styles from './EventCreationChoices.module.css';
import CustomButton from '../CustomButton';
import {
  logChooseChapterEvent,
  logChooseMemberEvent,
} from '../../../../shared/models/Analytics';

const EventCreationChoices = ({
  setCreateEventChoices,
  closeModalHandlers,
  createEventModal,
  setCreateEventModal,
}) => {
  const [isChapterEvent, setIsChapterEvent] = useState(false);

  const openCreateEventHandler = (type) => {
    if (type === 'chapter') {
      logChooseChapterEvent();
      setIsChapterEvent(true);
      setCreateEventModal((prevState) => !prevState);
      return;
    } else {
      logChooseMemberEvent();
      setCreateEventModal((prevState) => !prevState);
    }
  };

  return (
    <>
      <div className={styles.container}>
        <div className={styles.buttonWrapper}>
          <CustomButton
            onClick={() => openCreateEventHandler('chapter')}
            label={'Chapter Event'}
            buttonStyle={'secondary'}
          />
          <CustomButton
            onClick={() => openCreateEventHandler('member')}
            label={'Member Event'}
            buttonStyle={'secondary'}
          />
          <CustomButton
            onClick={() => closeModalHandlers()}
            label={'Cancel'}
            buttonStyle={'secondary'}
          />
        </div>
      </div>
      {createEventModal && (
        <CreateEvent
          closeModalHandlers={closeModalHandlers}
          setCreateEventChoices={setCreateEventChoices}
          isChapterEvent={isChapterEvent}
        />
      )}
    </>
  );
};

export default EventCreationChoices;
